import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

// Add a request interceptor to include the username in headers
axiosInstance.interceptors.request.use(
  (config) => {
    const userString = localStorage.getItem('user');
    let username = null;

    if (userString) {
      try {
        const userData = JSON.parse(userString);
        if (Array.isArray(userData) && userData.length > 0) {
          username = userData[0].UserName;
        }
      } catch (error) {
        console.error('Could not parse user data from localStorage:', error);
      }
    }

    if (username) {
      config.headers['X-Username'] = username;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;